import React from 'react';
import { Music, BookOpen, Award, Shirt } from 'lucide-react';
import { bonuses } from '../data/mock';

const Bonuses = () => {
  const iconMap = {
    music: Music,
    book: BookOpen,
    award: Award,
    shirt: Shirt
  };

  return (
    <section id="bonus" className="section-padding bg-gradient-to-b from-gray-900 to-black relative">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-16">
            <div className="inline-block bg-yellow-500/10 border border-yellow-500/30 px-6 py-2 rounded-full mb-4">
              <span className="text-yellow-400 font-semibold text-sm">BÔNUS EXCLUSIVOS</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
              Além do curso, você recebe
            </h2>
            <p className="text-base md:text-xl text-gray-400">
              Materiais e brindes exclusivos para turbinar seu aprendizado
            </p>
          </div>

          {/* Bonuses Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {bonuses.map((bonus, index) => {
              const Icon = iconMap[bonus.icon];
              return (
                <div
                  key={index}
                  className="glass p-6 rounded-xl text-center card-hover group"
                >
                  <div className="w-16 h-16 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-yellow-500/20 transition-colors duration-300">
                    <Icon className="w-8 h-8 text-yellow-400" />
                  </div>
                  <h3 className="text-lg font-bold text-white mb-2">{bonus.title}</h3>
                  <p className="text-gray-400 text-sm">{bonus.description}</p>
                </div>
              );
            })}
          </div>

          {/* Highlight Box */}
          <div className="bg-gradient-to-r from-yellow-500/10 to-green-500/10 border border-yellow-500/20 p-8 rounded-2xl">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div>
                <h3 className="text-2xl font-bold text-white mb-2">
                  Oferta por tempo limitado!
                </h3>
                <p className="text-gray-300">
                  Todos esses bônus são exclusivos para a próxima turma
                </p>
              </div>
              <a
                href="#inscricao"
                className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg font-bold transition-all duration-300 hover:scale-105 glow-green whitespace-nowrap"
              >
                GARANTIR BÔNUS
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Bonuses;
